import { createContext, useContext } from "react";

export function createSharedContext<R>(initContext: () => R) {
  const Context = createContext(null);

  function Provider({ children }) {
    const context = initContext();
    return <Context.Provider value={context}>{children}</Context.Provider>;
  }

  function useSharedContext() {
    const context = useContext(Context);
    if (!context) {
      throw new Error("useSharedContext must be used within a Provider");
    }
    return context;
  }

  return [Provider, useSharedContext] as const;
}
